import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/atoms/Button/Button';
import { Card } from '@/components/atoms/Card/Card';
import { Container } from '@/components/atoms/Container/Container';
import { Icon } from '@/components/atoms/Icon/Icon';

import { CareCircle } from '@karehero/models';

export const CannotBookCall = ({ careCircle, onBack }: CannotBookCallProps) => {
  const navigate = useNavigate();

  const { firstName = '', lastName = '' } =
    careCircle?.primaryCaregiverAccount || {};
  const caregiverName = `${firstName} ${lastName}`.trim();

  return (
    <Box sx={{ mb: '56px' }}>
      {onBack && (
        <Button
          ariaLabel='back'
          iconLeft='chevron-left'
          variant='secondary'
          size='sm'
          onPress={onBack}
        >
          Back
        </Button>
      )}

      <Container size='md'>
        <Stack sx={{ alignItems: 'center', gap: sp[16] }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '99999px',
              width: '40px',
              height: '40px',
              minWidth: '40px',
              minHeight: '40px',
              maxWidth: '40px',
              maxHeight: '40px',
              color: '#e7294b',
            }}
          >
            <Icon icon='circle-xmark' fontSize={48} type='fas' />
          </Box>
          <Box sx={{ typography: 'headingSm', color: '#000000' }}>
            Unable to book call
          </Box>
          <Card color='blue' elevation={0} isBordered={false} isPaddingSm>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                color: '#000000',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: sp[8],
                  typography: 'bodyMediumWeight',
                }}
              >
                Please contact {caregiverName} to book a call with your care
                experts.
              </Box>
            </Box>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

interface CannotBookCallProps {
  careCircle?: CareCircle;
  onBack?: () => void;
}

CannotBookCall.displayName = 'CannotBookCall';

export default CannotBookCall;
